// Google Analytics 4 (gtag.js) wrapper. No-op when the Measurement ID is absent.
const measurementId = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
const debug = process.env.REACT_APP_GA_DEBUG === "true";

export const analyticsEnabled = Boolean(measurementId);

function ensureGtag() {
  if (!analyticsEnabled || typeof window === "undefined") return false;
  if (typeof window.gtag === "function") return true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  // Route listener sends controlled page_views; avoid the automatic one.
  window.gtag("config", measurementId, { send_page_view: false });

  if (!document.querySelector(`script[data-ga4="${measurementId}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    script.dataset.ga4 = measurementId;
    document.head.appendChild(script);
  }
  return true;
}

// Derive town / vehicle from the current route so every event is attributable
// to a specific area or model page without touching individual components.
export function pageContext(pathname = window.location.pathname) {
  const parts = pathname.split("/").filter(Boolean);
  const ctx = { page_path: pathname };
  if (parts[0] === "car-remapping" || parts[0] === "car-keys") ctx.town = parts[1];
  if (parts[0] === "remap" && parts[2]) {
    ctx.vehicle = parts[1];
    ctx.town = parts[2];
  }
  if (parts[0] === "services" || parts[0] === "blog") ctx.content_slug = parts[1];
  ctx.page_type = parts[0] || "home";
  return ctx;
}

export function trackPageView(location) {
  if (!ensureGtag()) return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    ...pageContext(location.pathname),
    ...(debug ? { debug_mode: true } : {}),
  });
}

export function trackEvent(name, parameters = {}) {
  if (!ensureGtag()) return;
  const clean = Object.fromEntries(
    Object.entries(parameters).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  window.gtag("event", name, { ...clean, ...(debug ? { debug_mode: true } : {}) });
}

// Delegated click tracking for tel: and WhatsApp links anywhere on the site.
export function trackLeadClick(event) {
  const a = event.target.closest?.("a[href]");
  if (!a) return;
  const href = a.getAttribute("href") || "";
  const label = (a.getAttribute("data-testid") || a.textContent || "").trim().slice(0, 60);
  if (href.startsWith("tel:")) trackEvent("tel_click", { ...pageContext(), link_label: label });
  else if (/wa\.me|whatsapp\.com/.test(href)) trackEvent("whatsapp_click", { ...pageContext(), link_label: label });
  else if (/maps\.google|google\.com\/maps|g\.page/.test(href)) trackEvent("google_profile_click", { ...pageContext(), link_label: label });
}
